import { render, staticRenderFns } from "./ViewQuestionModal.vue?vue&type=template&id=446ff108&scoped=true&"
import script from "./ViewQuestionModal.vue?vue&type=script&lang=js&"
export * from "./ViewQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewQuestionModal.vue?vue&type=style&index=0&id=446ff108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ff108",
  null
  
)

export default component.exports